module.exports = __webpack_public_path__ + "static/media/retaliate.170dbe3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/bonuses/retaliate.svg
// module id = 158
// module chunks = 0